<template>
  <div v-if="user" class="payment-info-wrapper">
    <h4>Payment Info</h4>
    <div class="payment-info-item">Payment type - {{user.pm_type}}</div>
    <div class="payment-info-item" v-if="user.pm_type == 'bacs_debit'">Account ending - {{user.pm_last_four}}</div>
    <div class="payment-info-item" v-if="user.pm_type != 'bacs_debit'">Card number - **** **** **** {{user.pm_last_four}}</div>
    <div class="payment-info-item"></div>

    <a href="/payment-update?mode=update">
      <button type="button" class="btn btn-primary btn-small">Update</button>
    </a>
  </div>

</template>

<script>
export default {
  name: "PaymentInfo",
  data() {
    return {
      user: null
    }
  },
  methods: {
    getUser() {
      axios.get('/user').then((res) => {
        this.user = res.data
      }).catch((error) => {
        console.log('error', error)
      })
    },
  },
  created() {
    this.getUser()
  }
}
</script>

<style scoped>
.payment-info-wrapper{
  margin-bottom: 25px;
  font-size: 16px;
}
</style>